import { EVALUATION_STATES } from "./evaluation";
export var buyerStates = {
  make: {
    next: EVALUATION_STATES.BRAND_SELECTED,
    prev: EVALUATION_STATES.INITIAL
  },
  year: {
    next: EVALUATION_STATES.VEHICLE_AGE_SELECTED,
    prev: EVALUATION_STATES.INITIAL
  },
  price: {
    next: EVALUATION_STATES.INITIAL,
    prev: EVALUATION_STATES.BRAND_SELECTED
  },
  emi: {
    next: EVALUATION_STATES.INITIAL,
    prev: EVALUATION_STATES.BRAND_SELECTED
  },
  bodyType: {
    next: EVALUATION_STATES.VEHICLE_AGE_SELECTED,
    prev: EVALUATION_STATES.INITIAL
  }
};
export var cardStyle = {
  width: 'calc(50vw - 20px)',
  height: '60px',
  background: 'white',
  fontSize: '14px',
  fontWeight: 'bold',
  lineHeight: '60px',
  boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.08), 0 1px 1px -1px rgba(0, 0, 0, 0.09), 0 1px 6px 0 rgba(0, 0, 0, 0.14)',
  borderRadius: '4px'
};
export var selectedCardStyle = Object.assign(Object.assign({}, cardStyle), {
  width: 'calc(50vw - 22px)',
  height: '58px',
  lineHeight: '58px',
  border: '1px solid #5aece4'
});
export var bodyTypeCardStyle = Object.assign(Object.assign({}, cardStyle), {
  width: 'calc((100% - 24px))',
  display: 'inline-block',
  padding: '10px 12px',
  height: 'auto'
});
export var bodyTypeSelectedCardStyle = Object.assign(Object.assign({}, cardStyle), {
  width: 'calc((100% - 26px))',
  display: 'inline-block',
  padding: '8px 12px',
  height: 'auto',
  border: '1px solid #5aece4'
});
export var bodyTypeDisabledCardStyle = Object.assign(Object.assign({}, cardStyle), {
  width: 'calc((100% - 24px))',
  display: 'inline-block',
  padding: '10px 12px',
  height: 'auto',
  backgroundColor: '#d8dfe0',
  color: '#7f9799',
  boxShadow: 'none'
});
export var disabledCardStyle = Object.assign(Object.assign({}, cardStyle), {
  backgroundColor: '#d8dfe0',
  color: '#7f9799',
  boxShadow: 'none'
});
export var equalWidthColumnMetadata = {
  style: {
    backgroundColor: '#f8f9fa',
    marginTop: '0px',
    display: 'flex',
    flexWrap: 'wrap',
    padding: '0 16px 16px',
    justifyContent: 'space-between'
  }
};
export var equalWidthColumnMetadataBrandSelection = {
  style: {
    marginTop: '0px',
    display: 'flex',
    flexWrap: 'wrap',
    padding: '8px 12px 16px'
  }
};
export var cardTitle = {
  fontSize: '14px',
  lineHeight: '1.71',
  marginTop: 0,
  marginBottom: '8px'
};
export var COMMA_SEPERATOR = ',';
export var AMPERSAND_SEPERATOR = '&';
export var MAX_SEPERATOR = '_max=';
export var MIN_SEPERATOR = '_min=';
export var trackingEvents = {
  widgetFilters: 'widget_filters',
  searchListings: 'search_listings'
};
export var selectFrom = {
  make: 'brand',
  year: 'year',
  price_emi: 'price',
  body_type: 'type',
  price: 'price',
  emi: 'emi'
};